<template>
  <div>
    <!--HTML related information for displaying the component-->
    <template>
      <!-- <button onclick="onLoadRemoteJSON()">Afficher Rapport</button> -->
      <div id="pivot">Pivot</div>
    </template>
  </div>
</template> 

<!--JavaScript related information for the component's logic-->
<script>
import Flexmonster from "flexmonster";
export default /*#__PURE__*/ {
  name: "Pivot", // vue component name
  data:{
    formRef:"",
    dateStart:"",
    dateEnd:"",
  },
  props: {},
  mounted: function () {
    // base api url
    const apiUrl = axios.defaults.baseURL;

    this.flexmonster = new Flexmonster({
      container: "#pivot",
      toolbar: true,
      licenseKey: "Z7RK-XEGD4F-2U0W1H-4P2G5Z-0C5W0D-6H3B5Z-2K",
      global: {
        localization: "/lang/fr.json",
      },
      /* report: {
        localization: "/lang/fr.json",
      }, */

      // report: apiUrl + this.$router.currentRoute.name,
      report: {
        dataSource: {
          type: "json",
          filename: apiUrl + this.$router.currentRoute.name,
        },
      },
    });
  },
  beforeUpdate() {
    return false;
  },
  methods: {
    onLoadRemoteJSON() {
      const filename = prompt(
        "Ouvrir l'adresse des données depuis le serveur",
        apiUrl + this.$router.currentRoute.name + "/" + formRef
      );
      if (filename != null) {
        this.flexmonster.connectTo({
          type: "json",
          filename: filename,
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "~flexmonster/flexmonster.min.css";
</style>